import PropTypes from "prop-types";
import * as React from "react";
import { dedupeTags, normalizeTagString } from "../../../util/tagString";
import { Chip, SectionHead } from "../../../themeV2";
import TagSearch from "../../TagSearch";
import CharacterPicker from "./CharacterPicker";
import css from "./sections.module.css";

const TagsSection = function TagsSection({
  state,
  dispatch,
  isAdmin,
  readOnly,
}) {
  const setTags = (tags) => dispatch({ type: "setTags", tags });
  const setSpecial = (changes) =>
    dispatch({
      type: "setSpecialTags",
      characterTagString: state.characterTagString,
      franchiseTagString: state.franchiseTagString,
      ...changes,
    });

  return (
    <section className={css.section}>
      <SectionHead title="Tags and categories" as="h3" />

      {!readOnly && (
        <TagSearch
          clearOnBlur
          onAddTag={(raw) =>
            setTags(
              dedupeTags([
                ...state.tags,
                { tagString: normalizeTagString(raw) },
              ]).filter((tag) => tag.tagString),
            )
          }
          onRemoveTag={() => {}}
        />
      )}

      {state.tags.length > 0 && (
        <div className={css.chips}>
          {state.tags.map(({ tagString }) => (
            <Chip
              key={tagString}
              variant="input"
              size="sm"
              label={tagString}
              onDelete={
                readOnly
                  ? undefined
                  : () =>
                      setTags(
                        state.tags.filter((t) => t.tagString !== tagString),
                      )
              }
            />
          ))}
        </div>
      )}

      <div className={css.pair}>
        <TagSearch
          isCharacter
          tag={state.characterTagString}
          onAddTag={(characterTagString) => setSpecial({ characterTagString })}
          onRemoveTag={() => setSpecial({ characterTagString: null })}
        />
        <TagSearch
          isFranchise
          tag={state.franchiseTagString}
          onAddTag={(franchiseTagString) => setSpecial({ franchiseTagString })}
          onRemoveTag={() => setSpecial({ franchiseTagString: null })}
        />
      </div>

      {isAdmin && (
        <CharacterPicker
          characters={state.characters}
          onChange={(characters) =>
            dispatch({ type: "setCharacters", characters })
          }
        />
      )}
    </section>
  );
};

TagsSection.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  readOnly: PropTypes.bool,
  state: PropTypes.object.isRequired,
};

export default TagsSection;
